import { logError } from "@olenbetong/appframe-core";

type TaskItem = {
	key: string;
	text: string;
	href: string;
	severity?: string;
	description?: string;
};

type TaskGroup = {
	title: string;
	items: TaskItem[];
};

type TaskResult = {
	providerId: string;
	count: number;
	details: TaskGroup | null;
};

function addArticleBadges(articleId: string, count: number) {
	const menuBadge = document.createElement("span");
	menuBadge.className = "badge badge-pill badge-danger ml-auto";
	menuBadge.innerText = String(count);

	const menuLink = document.querySelector(`.c-sidebar [href*=${articleId}]`);
	if (menuLink) {
		menuLink.classList.add("d-flex");
		menuLink.append(menuBadge);
	}
}

async function doStatusChecks() {
	try {
		let resp = await fetch("/api/tasks");
		if (!resp.ok) {
			throw new Error(`Failed to fetch tasks: ${resp.status} ${resp.statusText}`);
		}
		let results: TaskResult[] = await resp.json();
		for (let result of results) {
			if (result.count > 0) {
				addArticleBadges(result.providerId, result.count);
			}
		}
	} catch (error) {
		logError(error);
	}
}

document.addEventListener("DOMContentLoaded", doStatusChecks);
